import { createSlice } from '@reduxjs/toolkit'

export type ResetPageStateType = {
  CreatePin: string
  CreatePinHidden: boolean
  ConfirmPin: string
  ConfirmPinHidden: boolean
  ErrBoxOption: number | null
}

const initialState: ResetPageStateType = {
  CreatePin: '',
  CreatePinHidden: true,
  ConfirmPin: '',
  ConfirmPinHidden: true,
  ErrBoxOption: null,
}

const ResetPageSlice = createSlice({
  name: 'ResetPage',
  initialState,
  reducers: {
    setCreatePin(state, action) {
      state.CreatePin = action.payload
    },
    setCreatePinHidden(state, action) {
      state.CreatePinHidden = action.payload
    },
    setConfirmPin(state, action) {
      state.ConfirmPin = action.payload
    },
    setConfirmPinHidden(state, action) {
      state.ConfirmPinHidden = action.payload
    },
    ResetCreatePin(state) {
      state.CreatePin = ''
    },
    ResetConfirmPin(state) {
      state.ConfirmPin = ''
    },
  },
})

export const {
  setCreatePin,
  ResetCreatePin,
  ResetConfirmPin,
  setCreatePinHidden,
  setConfirmPin,
  setConfirmPinHidden,
} = ResetPageSlice.actions

export default ResetPageSlice.reducer
